import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestHooks } from './tab.hooks';

@Component({
	selector: 'ui-tab',
	imports: [CommonModule],
	templateUrl: './tab.component.html',
})
export class TabComponent {
	testHooks = TestHooks;
	@Input() title!: string;
	@Input() id!: string;
	@ViewChild('content') template!: TemplateRef<void>;
	@ViewChild('postTitleTpl') postTitleTemplate!: TemplateRef<void>;
	@ViewChild('preTitleTpl') preTitleTemplate!: TemplateRef<void>;
}
